export default __webpack_public_path__ + "static/media/hihat.46e533fc.wav";